import type { ISwSettings } from "app/@types/ISwSettings";
import { swSettings } from "app/common/services/swSettings";
import { SI_ROOT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import {
    EXTENSION_MANAGEMENT_MANAGE_ROUTE,
    EXTENSION_MANAGEMENT_MANAGE_URL,
} from "app/pages/sales-intelligence/constants/sl_routes";
import { ExtensionManagementContainer } from "app/pages/sales-intelligence/pages/management/containers/ExtensionManagementContainer/ExtensionManagementContainer";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import { isAfterTrial, isNoTouch, isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";
import { salesRouteGate } from "single-spa/react-app/config/solutions25/sales/utils/salesRouteGate";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

const canManageExtension = (): boolean =>
    !(isTrial(swSettings as ISwSettings) || isAfterTrial(swSettings as ISwSettings) || isNoTouch(swSettings as ISwSettings));

export const extensionManageConfig: RouterStateConfig = {
    [EXTENSION_MANAGEMENT_MANAGE_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: EXTENSION_MANAGEMENT_MANAGE_URL,
        configId: "SalesWorkspace",
        stateId: EXTENSION_MANAGEMENT_MANAGE_ROUTE,
        component: ExtensionManagementContainer,
        pageTitle: "si.pages.management.document_title",
        trackingId: {
            section: "SI_admin",
            subSection: "integrations",
            subSubSection: "manage browser extension",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        redirectTo: salesRouteGate(canManageExtension),
        isHidden: (): boolean => !canManageExtension(),
    },
};
